module.exports = {
      id: "video-usage",
      viewBox: "0 0 54 37",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#video",
      toString: function () {
        return this.url;
      }
    }